// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"88ef8525","453":"0053730f","990":"0c1dea8e"}[chunkId] + ".chunk.js";
};